import { injectable } from 'tsyringe'
import { AdminCMSRoleApiRepository } from '@/app/repositories/api/AdminCMSRoleApiRepository'
import { RoleCMSS } from '@/domain/entities/AdminCMSRole'
import {
  DeleteAdminCMSRoleInterface,
  PostAdminCMSRoleInterface,
  UpdateAdminCMSRoleInterface,
} from '@/data/payload/contracts/AdminCMSRoleRequest'

@injectable()
export class AdminCMSRolePresenter {
  private repository: AdminCMSRoleApiRepository

  constructor(repository: AdminCMSRoleApiRepository) {
    this.repository = repository
  }

  public loadAdminCMSRole(params: Object): Promise<RoleCMSS> {
    return this.repository.getAll(params)
  }
  public postAdminCMSRole(
    payload: PostAdminCMSRoleInterface
  ): Promise<RoleCMSS> {
    return this.repository.post(payload)
  }
  public deleteAdminCMSRole(
    payload: DeleteAdminCMSRoleInterface
  ): Promise<RoleCMSS> {
    return this.repository.delete(payload)
  }
  public updateAdminCMSRole(
    payload: UpdateAdminCMSRoleInterface,
    id: number
  ): Promise<RoleCMSS> {
    return this.repository.update(payload, id)
  }
}
